








import { Prop, Component, Vue } from "vue-property-decorator";
import { Staff } from "@/api/company-api";

@Component({})
export default class StaffListItem extends Vue {
  @Prop({ required: true }) staff!: Staff;
}
